import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { toast } from "react-toastify";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faEdit,
  faMoneyBillAlt,
  faRecycle,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

function Account({ name, id, changeAccount, role, resetUserCodes }) {
  return (
    <Col className="account-element">
      <Row>
        <Col lg={6}>
          <h5
            onClick={() =>
              changeAccount(id, () => toast(`${name} seleccionado`))
            }
          >
            {name}
          </h5>
        </Col>
        <Col lg={6} className="right">
          <Dropdown>
            <Dropdown.Toggle
              id="dropdown-basic"
              style={{ backgroundColor: "#03acbe", borderColor: "#03acbe" }}
            >
              <FontAwesomeIcon icon={faBars} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item as={Link} to={`/edit-account/${id}`}>
                <FontAwesomeIcon
                  icon={faEdit}
                  style={{ color: "#555", marginRight: 5 }}
                />
                Editar
              </Dropdown.Item>
              <Dropdown.Item as={Link} to={`/edit-account-payout/${id}`}>
                <FontAwesomeIcon
                  icon={faMoneyBillAlt}
                  style={{ color: "#555", marginRight: 5 }}
                />
                Editar cuota
              </Dropdown.Item>
              <Dropdown.Item as={Link} to={`/delete-account/${id}`}>
                <FontAwesomeIcon
                  icon={faTrash}
                  style={{ color: "#555", marginRight: 5 }}
                />
                Eliminar
              </Dropdown.Item>
              {role === "root" ? (
                <Dropdown.Item onClick={() => resetUserCodes(id)}>
                  <FontAwesomeIcon
                    icon={faRecycle}
                    style={{ color: "#555", marginRight: 5 }}
                  />
                  Reset códigos
                </Dropdown.Item>
              ) : (
                <></>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>
    </Col>
  );
}

export default Account;
